import dayjs from 'dayjs'

const dateFormat = date => dayjs(date).format('DD/MM/YYYY')

export default dateFormat
